import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Seite nicht gefunden | Sportwetten NRW" description="Diese Seite existiert nicht." path="/404" />
      <section className="mx-auto flex max-w-3xl flex-col items-center px-4 py-28 text-center sm:px-6" data-testid="not-found-page">
        <p className="font-display text-6xl font-extrabold text-[#F54855]">404</p>
        <h1 className="mt-4 font-display text-2xl font-bold text-[#F5F5F3]">Seite nicht gefunden</h1>
        <p className="mt-3 text-[#A1A1AA]">Die angeforderte Seite existiert nicht oder wurde verschoben.</p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex min-h-[48px] items-center justify-center rounded-lg bg-[#E11D2A] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#F02837]"
            data-testid="not-found-home-link"
          >
            Zur Startseite
          </Link>
          <Link
            to="/standorte"
            className="inline-flex min-h-[48px] items-center justify-center rounded-lg border border-[#27272A] px-6 py-3 text-sm font-semibold text-[#F5F5F3] transition-colors hover:border-[#E11D2A]/40 hover:bg-[#1E1E24]"
            data-testid="not-found-standorte-link"
          >
            Standorte ansehen
          </Link>
        </div>
      </section>
    </>
  );
}
